<template>
  <div class="flex flex-col justify-center items-center text-center gap-m bg-secondary-40  rounded-xl p-l text-white">
    <Icon
      name="iad-icon:homepilot"
      class="w-28 h-20"
      title="Logo Homepilot"
    />
    <IadTitle
      tag="p"
      class="text-balance"
      :text="$t('property_serp.promo.homepilot.title')"
    />
    <IadTitle
      tag="span"
      variant="x-small"
      class="text-pretty"
      :text="$t('property_serp.promo.homepilot.subtitle')"
    />
    <IadBtn
      href="https://www.homepilot.fr/"
      target="_blank"
      :text="$t('core.common.discover')"
    />
  </div>
</template>
